<script lang="ts">
	import { page } from '$app/stores';
	import pageError from '$lib/assets/page-error.png';

	function getErrorMessages(status: number) {
		if (status === 401) {
			return {
				title: 'Unauthorized',
				subtitle: 'You need to be logged in to view this page'
			};
		} else if (status === 403) {
			return {
				title: 'Forbidden',
				subtitle: 'Your account does not have permission to view this page.'
			};
		} else if (status === 404) {
			return {
				title: 'Page Not Found',
				subtitle: "Sorry we couldn't Grabbit!"
			};
		} else if (status >= 500 && status < 600) {
			return {
				title: 'Server Error',
				subtitle: "We're going to fix this for you!"
			};
		} else {
			return {
				title: 'Something Unexpected Happened',
				subtitle: 'Maybe you can try reloading.'
			};
		}
	}

	let { title, subtitle } = getErrorMessages($page.status);
</script>

<div class="flex grow flex-col items-center justify-center gap-4">
	<img class="max-h-[250px]" src={pageError} alt="Page Error" />
	<h1 class="text-title1 font-bold">{title}</h1>
	<span class="text-title2">{subtitle}</span>
</div>
